import { LifecycleStatus, Product } from '@/gql/graphql';

export const isProductTailoringEnabled = (userId: string, product?: Product) => {
  if (!product) return false;
  return (
    (product.lifecycleStatus === LifecycleStatus.New && product.owner.id === userId) ||
    (product.lifecycleStatus === LifecycleStatus.InProgress && product.owner.id === userId)
  );
};

export const isProductStatusChangeEnabled = (userId: string, product?: Product) => {
  if (!product) return false;
  return (
    (product.lifecycleStatus === LifecycleStatus.InProgress && product.owner.id === userId) ||
    (product.lifecycleStatus === LifecycleStatus.Retired && product.owner.id === userId)
  );
};

export const isProductEditEnabled = (userId: string, product?: Product) => {
  if (!product) return false;
  return product.lifecycleStatus !== LifecycleStatus.Retired && product.owner.id === userId;
};

export const isProductCopyEnabled = (product?: Product) => {
  if (!product) return false;
  return product.lifecycleStatus !== LifecycleStatus.Retired && product.lifecycleStatus !== LifecycleStatus.New;
};

export const isProductDeleteEnabled = (userId: string, product?: Product) => {
  if (!product) return false;
  return product.owner.id === userId;
};
